var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-avatar',{attrs:{"size":_vm.size}},[(_vm.avatarUrl)?_c('img',{attrs:{"src":_vm.url,"alt":"avatar"}}):_c('v-icon',{attrs:{"size":_vm.size}},[_vm._v("account_circle")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }